import { Component, EventEmitter, Input, OnInit, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { DocumentTypeService } from '../../../../core/services/document/document-type/document-type.service';
import { SupplierService } from '../../../../core/services/person/supplier/supplier.service';
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service';
import { uploadDocSupplier } from '../../../../core/models/supplier.model';

@Component({
  selector: 'document-upload-form-edit',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule
  ],
  templateUrl: './document-upload-form.component.html',
  styleUrl: './document-upload-form.component.scss',
  providers: [DocumentTypeService],
})
export class DocumentUploadFormEdit implements OnInit, OnChanges {
  @Input() item: any;
  @Input() fornecedorId: any;
  @Output() response = new EventEmitter<any>();

  form!: FormGroup;
  loading: boolean = false;
  file: File | null = null;
  fileName: string = '';
  listType: any[] = [];
  isEditing: boolean = false;

  constructor(
    private fb: FormBuilder,
    private documentTypeService: DocumentTypeService,
    private supplierService: SupplierService,
    private snackbar: SnackbarCustomService,
  ) { }

  ngOnInit(): void {
    this.createForm();
    this.getListTypeDoc();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['item'] && changes['item'].currentValue) {
      this.populateForm(changes['item'].currentValue);
    }
  }

  createForm(): void {
    this.form = this.fb.group({
      id: [null],
      docType: [null, Validators.required],
      description: ['', Validators.required],
      file: ['', Validators.required]
    });
  }

  populateForm(item: any): void {
    this.isEditing = true;


    const selectedType = this.listType.find(t => t.id === item.tipoDocId);

    this.form.patchValue({
      id: item.id,
      docType: selectedType,
      description: item.descricao,
      file: item.nomeArquivo
    });

    this.fileName = item.nomeArquivo;
    this.form.get('file')?.disable();
  }

  onFileSelected(event: Event): void {
    if (this.isEditing) return;

    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.file = input.files[0];
      this.fileName = this.file.name;
      this.form.get('file')?.setValue(this.fileName);
    }
  }

  submit(): void {
    if (this.form.invalid && !this.isEditing) return;

    this.loading = true;
    if (this.isEditing) {
      this.updateDocument();
    } else {
      this.saveDocument();
    }
  }

  saveDocument(): void {
    const formData = this.prepareFormData();
    this.supplierService.uploadDocSupplier(formData).subscribe({
      next: (res: any) => {
        this.snackbar.success(res.message);
        this.response.emit({ action: 'create', data: res.data });
        this.resetForm();
      },
      error: (err) => { this.loading = false; this.snackbar.errorRequest(err); }
    });
  }

  updateDocument(): void {
    const payload = {
      Id: this.form.get('id')?.value,
      Descricao: this.form.get('description')?.value,
      TipoDocId: this.form.get('docType')?.value?.id,
      FornecedorId: this.fornecedorId
    };

    this.loading = true;
    this.supplierService.editDocSupplier(payload).subscribe({
      next: (res: any) => {
        this.snackbar.success(res.message);

        this.response.emit({
          action: 'edit',
          item: res.data
        });

        this.resetForm();
      },
      error: (err: any) => {
        this.loading = false;
        this.snackbar.errorRequest(err);
        console.error('Erro na edição:', err);
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  private prepareFormData(): FormData {
    const model = new uploadDocSupplier();
    model.arquivo = {
      FileObject: this.file,
      descricao: this.form.get('description')?.value,
      fornecedorId: this.fornecedorId,
      tipoDocId: this.form.get('docType')?.value?.id
    };
    return model.toFormData();
  }

  resetForm(): void {
    this.isEditing = false;
    this.form.reset();
    this.form.get('file')?.enable();
    this.file = null;
    this.fileName = '';
    this.loading = false;
  }

  getListTypeDoc(): void {
    this.documentTypeService.listDocumentType().subscribe({
      next: (res: any) => this.listType = res.data
    });
  }

  getAllowedTypes(): string {
    return '.pdf, .jpg, .jpeg, .png';
  }
}
